import useRewriteUrl from 'hooks/useRewriteUrl';

function RewriteUrlComponent() {
  useRewriteUrl();
  return null;
}

export default RewriteUrlComponent;
